import { render, staticRenderFns } from "./TcNewAppointment.vue?vue&type=template&id=589ec35e&"
import script from "./TcNewAppointment.vue?vue&type=script&lang=js&"
export * from "./TcNewAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589ec35e')) {
      api.createRecord('589ec35e', component.options)
    } else {
      api.reload('589ec35e', component.options)
    }
    module.hot.accept("./TcNewAppointment.vue?vue&type=template&id=589ec35e&", function () {
      api.rerender('589ec35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcNewAppointment.vue"
export default component.exports